import { useEffect, useState } from "react";
import api from "@/lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const AccountDeletionRequest = () => {
  const [request, setRequest] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/me/deletion-request").then(({ data }) => setRequest(data.request)).catch(() => {});
  }, []);

  const submit = async () => {
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/me/deletion-request");
      setRequest(data.request);
    } catch (e) {
      setError("We couldn't send your request. Please try again, or email info@CaesarsGhost.ca.");
    } finally { setBusy(false); }
  };

  return (
    <section className="mt-16 border-t border-[var(--cg-border)] pt-8" data-testid="account-deletion-section">
      <p className="cg-eyebrow mb-2">Your account</p>
      {request ? (
        <p className="text-sm text-[#B9BDC7] leading-relaxed max-w-2xl" data-testid="deletion-request-received">
          We've received your request to delete your account and personal assessment information
          (sent {request.created_at?.slice(0, 10)}). Our team will review it and contact you at your account email.
          Your account stays active until then.
        </p>
      ) : (
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <button data-testid="request-account-deletion-button"
              className="text-sm text-[#9CA3AF] border border-[var(--cg-border)] rounded-full px-5 py-2 hover:text-terracotta hover:border-terracotta transition-colors">
              Request Account Deletion
            </button>
          </AlertDialogTrigger>
          <AlertDialogContent data-testid="deletion-confirm-dialog">
            <AlertDialogHeader>
              <AlertDialogTitle>Request account deletion?</AlertDialogTitle>
              <AlertDialogDescription asChild>
                <div className="space-y-3 text-sm">
                  <p>You can ask us to delete your Caesar's Ghost account and your personal assessment information, including your answers and Authority Portraits.</p>
                  <p>Nothing is deleted right away. Our team will review your request and contact you at your account email before anything is removed. Some records, such as payment records, may need to be kept for legal or accounting reasons.</p>
                </div>
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel data-testid="deletion-cancel-button">Cancel</AlertDialogCancel>
              <AlertDialogAction data-testid="deletion-confirm-button" disabled={busy} onClick={submit}>
                {busy ? "Sending…" : "Yes, send my request"}
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}
      {error && <p className="mt-3 text-sm text-terracotta" data-testid="deletion-request-error">{error}</p>}
    </section>
  );
};
